const PAYMENTPASSWORD = 'payment_password';
const GOOGLEAUTH = 'google_auth';
const VERIFYEMAIL = 'email';

export { PAYMENTPASSWORD, VERIFYEMAIL, GOOGLEAUTH};